import React, { useState } from "react";
import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { companyRoleLabel } from "./SEC_CompanyRoles";

export default function SEC_CompanyUsersView({
  companyName,
  data,
  loading,
  searching,
  searchResults,
  availableRoles = [],
  onSearch,
  onAssign,
  onRevoke
}) {
  const [showAddRow, setShowAddRow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pickedUser, setPickedUser] = useState(null);
  const [tempRole, setTempRole] = useState("");

  const resetAddRow = () => {
    setShowAddRow(false);
    setSearchTerm("");
    setPickedUser(null);
    setTempRole("");
  };

  const handleSearch = () => {
    if (searchTerm.trim().length > 0 && onSearch) onSearch(searchTerm.trim());
  };

  const handleConfirmAssign = () => {
    if (!pickedUser || !tempRole) return;
    onAssign(GoldenSourceHelper.get(pickedUser, "SiteUserGuid"), tempRole);
    resetAddRow();
  };

  return (
    <div className="card shadow-sm border-0 bg-white overflow-hidden animate__animated animate__fadeIn">
      {/* 🎯 CLEAR DIVISION FROM SUSTINA PLATFORM USERS */}
      <div className="p-3 border-bottom bg-light d-flex justify-content-between align-items-center">
        <div>
          <h6 className="fw-bold extra-small text-uppercase text-primary mb-0">
            <i className="bi bi-building-lock me-1"></i> Company Users — {companyName || "Selected Entity"}
          </h6>
          <span className="extra-small text-muted">
            Reader / Approver / Manager access to this company's ESG reporting only — not a Sustina platform user.
          </span>
        </div>
        {!showAddRow && (
          <button className="btn btn-xs btn-dark fw-bold px-3" onClick={() => setShowAddRow(true)}>
            <i className="bi bi-person-plus me-1"></i> ADD USER
          </button>
        )}
      </div>

      {showAddRow && (
        <div className="p-3 border-bottom bg-white">
          {!pickedUser ? (
            <div className="d-flex gap-2 align-items-start">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by name or email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
              <button className="btn btn-sm btn-outline-dark" onClick={handleSearch} disabled={searching}>
                {searching ? "..." : "Search"}
              </button>
              <button className="btn btn-sm btn-link text-muted" onClick={resetAddRow}>Cancel</button>
            </div>
          ) : (
            <div className="d-flex gap-2 align-items-center">
              <span className="badge bg-light border text-dark small">
                {GoldenSourceHelper.get(pickedUser, "userName") || GoldenSourceHelper.get(pickedUser, "UserName")}
              </span>
              <select
                className="form-select form-select-sm"
                style={{ maxWidth: "200px" }}
                value={tempRole}
                onChange={(e) => setTempRole(e.target.value)}
              >
                <option value="">-- Role --</option>
                {availableRoles.map((r) => (
                  <option key={r.code} value={r.code}>
                    {r.label}
                  </option>
                ))}
              </select>
              <button
                className="btn btn-sm btn-primary fw-bold"
                onClick={handleConfirmAssign}
                disabled={!tempRole}
              >
                Confirm
              </button>
              <button className="btn btn-sm btn-link text-muted" onClick={resetAddRow}>Cancel</button>
            </div>
          )}

          {!pickedUser && searchResults.length > 0 && (
            <div className="list-group mt-2" style={{ maxWidth: "420px" }}>
              {searchResults.map((u, idx) => (
                <button
                  type="button"
                  key={idx}
                  className="list-group-item list-group-item-action small d-flex justify-content-between"
                  onClick={() => setPickedUser(u)}
                >
                  <span className="fw-bold">
                    {GoldenSourceHelper.get(u, "userName") || GoldenSourceHelper.get(u, "UserName")}
                  </span>
                  <span className="text-muted">
                    {GoldenSourceHelper.get(u, "emailAddress") || GoldenSourceHelper.get(u, "EmailAddress")}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-hover mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th className="extra-small text-muted py-3 ps-3">USER</th>
              <th className="extra-small text-muted py-3">ROLE</th>
              <th className="extra-small text-muted py-3">ASSIGNED BY</th>
              <th className="extra-small text-muted py-3 text-end pe-3">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="4" className="text-center p-4 text-muted extra-small italic">Loading company users...</td></tr>
            ) : data.length > 0 ? (
              data.map((row, i) => {
                const siteUserGuid = GoldenSourceHelper.get(row, "SiteUserGuid");
                const roleCode = GoldenSourceHelper.get(row, "CompanyRoleCode");
                return (
                  <tr key={i} className="small">
                    <td className="ps-3 fw-bold">{GoldenSourceHelper.get(row, "UserName")}</td>
                    <td>
                      <span className="badge bg-white border text-dark extra-small">
                        {companyRoleLabel(roleCode)}
                      </span>
                    </td>
                    <td className="text-muted extra-small">{GoldenSourceHelper.get(row, "AssignedBy_UserName")}</td>
                    <td className="text-end pe-3">
                      <button
                        className="btn btn-link btn-sm p-0 text-danger"
                        onClick={() => onRevoke(siteUserGuid, roleCode)}
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr><td colSpan="4" className="text-center p-4 text-muted extra-small italic">No users have access to this company yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
